import request from '@/utils/request'

export function getEmps91D0(param) {
  let data = param
  return request({
    url: `/deliveryReport/epms91D0/getEmps91D0`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}



//epms91D0Xls
export function epms91D0Xls(param) {
  let data = param
  return request({
    url: `/deliveryReport/epms91D0/epms91D0Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms6500Xls RES', res)

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `91.D Not Yet Delivery Status (by POR).xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}